"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@apollo/client");
const format_1 = __importDefault(require("date-fns/format"));
const client_2 = require("../../client");
const utils_1 = require("../help/sanity/serializers/utils");
require("./BlogPostCard.css");
(0, client_1.gql) `
  fragment BlogPostCard on Post {
    _id
    title
    slug {
      current
    }
    author {
      name
      slug {
        current
      }
    }
    mainImage {
      asset {
        _id
        url
        path
        assetId
        extension
      }
    }
    publishedAt
  }
`;
function BlogPostCard({ post }) {
    const builder = (0, utils_1.useSanityImageUrlBuilder)();
    const { gotoBlogPost } = (0, client_2.useMapmakerAppConfig)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "blog-post-card", onClick: () => gotoBlogPost(post.slug.current) }, { children: [(0, jsx_runtime_1.jsx)("img", { src: builder
                    .image(post.mainImage.asset)
                    .crop("focalpoint")
                    .width(512)
                    .height(512)
                    .fit("crop")
                    .url() }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "info" }, { children: [(0, jsx_runtime_1.jsx)("h3", { children: post.title }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "date" }, { children: (0, format_1.default)(Date.parse(post.publishedAt), "PPP") }))] }))] })));
}
exports.default = BlogPostCard;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmxvZ1Bvc3RDYXJkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvYmxvZy9CbG9nUG9zdENhcmQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLDJDQUFxQztBQUNyQyw2REFBcUM7QUFDckMseUNBQW9EO0FBRXBELDREQUE0RTtBQUM1RSw4QkFBNEI7QUFFNUIsSUFBQSxZQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXdCRixDQUFDO0FBTUYsU0FBd0IsWUFBWSxDQUFDLEVBQUUsSUFBSSxFQUFxQjtJQUM5RCxNQUFNLE9BQU8sR0FBRyxJQUFBLGdDQUF3QixHQUFFLENBQUM7SUFDM0MsTUFBTSxFQUFFLFlBQVksRUFBRSxHQUFHLElBQUEsNkJBQW9CLEdBQUUsQ0FBQztJQUNoRCxPQUFPLENBQ0wsK0NBQUssRUFBRSxFQUFDLGdCQUFnQixFQUFDLE9BQU8sRUFBRSxHQUFHLEVBQUUsQ0FBQyxZQUFZLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsaUJBQ3JFLGdDQUNFLEdBQUcsRUFBRSxPQUFPO3FCQUNULEtBQUssQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLEtBQUssQ0FBQztxQkFDM0IsSUFBSSxDQUFDLFlBQVksQ0FBQztxQkFDbEIsS0FBSyxDQUFDLEdBQUcsQ0FBQztxQkFDVixNQUFNLENBQUMsR0FBRyxDQUFDO3FCQUNYLEdBQUcsQ0FBQyxNQUFNLENBQUM7cUJBQ1gsR0FBRyxFQUFFLEdBQ1IsRUFDRiwrQ0FBSyxTQUFTLEVBQUMsTUFBTSxpQkFDbkIseUNBQUssSUFBSSxDQUFDLEtBQUssR0FBTSxFQUNyQiw4Q0FBSyxTQUFTLEVBQUMsTUFBTSxnQkFDbEIsSUFBQSxnQkFBTSxFQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxFQUFFLEtBQUssQ0FBQyxJQUN4QyxLQUNGLEtBQ0YsQ0FDUCxDQUFDO0FBQ0osQ0FBQztBQXRCRCwrQkFzQkMifQ==